// extracted by mini-css-extract-plugin
export default {"container":"admins-table_container__r2CPP"};